// frontend/src/components/Skeleton.tsx

import React from 'react';

interface SkeletonProps {
  rows?: number;
  className?: string;
  width?: string | number;
  height?: string | number;
}

const Skeleton: React.FC<SkeletonProps> = ({ rows = 3, className = "", width, height }) => {
  return (
    <div className={`space-y-4 ${className}`}>
      {[...Array(rows)].map((_, i) => (
        <div 
          key={i} 
          className="skeleton-pulse rounded mx-auto" 
          style={{ 
            width: width !== undefined ? width : (i === 0 && rows > 1 ? "100%" : "80%"), 
            height: height !== undefined ? height : "16px",
            background: "var(--skeleton-bg, var(--color-surface-2))",
            animationDuration: "1.5s",
            animationName: "pulse-opacity"
          }}
        ></div>
      ))}
    </div>
  );
};

export default Skeleton;
